
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/health-tools",
      function () {
        return require("private-next-pages/health-tools/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/health-tools"])
      });
    }
  